import { useNavigate } from 'react-router-dom'

export default function ThankYou() {
  const navigate = useNavigate()

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div className="card" style={{ maxWidth: '600px', width: '100%', textAlign: 'center' }}>
        <div style={{ marginBottom: '32px' }}>
          <div style={{ fontSize: '72px', marginBottom: '24px' }}>✓</div>
          <h1 style={{ fontSize: '36px', marginBottom: '14px', textAlign: 'center', fontWeight: '800', color: '#98FB98', textShadow: '0 0 15px rgba(152, 251, 152, 0.8)', fontFamily: 'VT323, monospace', letterSpacing: '2px' }}>
            &gt; REQUEST RECEIVED
          </h1>
          <h2 style={{ fontSize: '24px', marginBottom: '28px', textAlign: 'center', fontWeight: '700', color: '#98FB98', textShadow: '0 0 12px rgba(152, 251, 152, 0.7)', fontFamily: 'VT323, monospace', letterSpacing: '2px' }}>
            &gt; PROCESSING...
          </h2>
        </div>

        <div style={{
          padding: '28px',
          background: 'linear-gradient(135deg, rgba(152, 251, 152, 0.15) 0%, rgba(34, 139, 34, 0.3) 100%)',
          borderRadius: '16px',
          border: '2px solid rgba(152, 251, 152, 0.4)',
          marginBottom: '32px',
          boxShadow: '0 6px 12px rgba(34, 139, 34, 0.2), 0 0 20px rgba(152, 251, 152, 0.3)'
        }}>
          <p style={{ fontSize: '18px', color: '#98FB98', lineHeight: '1.8', marginBottom: '16px', textShadow: '0 0 10px rgba(152, 251, 152, 0.6)', fontWeight: '600' }}>
            Thank you for your request.
          </p>
          <p style={{ fontSize: '16px', color: 'rgba(152, 251, 152, 0.9)', lineHeight: '1.7', textShadow: '0 0 8px rgba(152, 251, 152, 0.5)' }}>
            You will be reviewed and approved shortly.
          </p>
        </div>

        <div style={{
          padding: '20px',
          background: 'rgba(34, 139, 34, 0.1)',
          borderRadius: '12px',
          border: '1px solid rgba(152, 251, 152, 0.25)',
          marginBottom: '28px'
        }}>
          <p style={{ fontSize: '14px', color: 'rgba(152, 251, 152, 0.85)', lineHeight: '1.7', marginBottom: '12px', textShadow: '0 0 5px rgba(152, 251, 152, 0.4)' }}>
            <strong style={{ color: '#98FB98' }}>What happens next:</strong>
          </p>
          <ul style={{
            textAlign: 'left',
            fontSize: '14px',
            color: 'rgba(152, 251, 152, 0.85)',
            lineHeight: '1.8',
            paddingLeft: '24px',
            margin: 0,
            textShadow: '0 0 5px rgba(152, 251, 152, 0.3)'
          }}>
            <li style={{ marginBottom: '8px' }}>Our team will review your access request</li>
            <li style={{ marginBottom: '8px' }}>You will receive an email notification with your decision</li>
            <li style={{ marginBottom: '8px' }}>If approved, you'll receive login credentials to access the system</li>
            <li>Typical review time: 24-48 hours</li>
          </ul>
        </div>

        <button
          onClick={() => navigate('/')}
          className="btn"
          style={{ width: '100%', marginTop: '12px' }}
        >
          Return to Main
        </button>
      </div>
    </div>
  )
}
